/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserIdDto } from './UserIdDto';
import {
    UserIdDtoFromJSON,
    UserIdDtoFromJSONTyped,
    UserIdDtoToJSON,
} from './UserIdDto';

/**
 * 
 * @export
 * @interface CancelDeleteUserDto
 */
export interface CancelDeleteUserDto {
    /**
     * 
     * @type {UserIdDto}
     * @memberof CancelDeleteUserDto
     */
    userId: UserIdDto;
}

/**
 * Check if a given object implements the CancelDeleteUserDto interface.
 */
export function instanceOfCancelDeleteUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function CancelDeleteUserDtoFromJSON(json: any): CancelDeleteUserDto {
    return CancelDeleteUserDtoFromJSONTyped(json, false);
}

export function CancelDeleteUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelDeleteUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': UserIdDtoFromJSON(json['userId']),
    };
}

export function CancelDeleteUserDtoToJSON(value?: CancelDeleteUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': UserIdDtoToJSON(value.userId),
    };
}

